import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import initialState from './aorcmInitialState';
import axios from 'axios';
import {
  _setCaseManagerOrParoleAgent,
  _setEndDate,
  _setRecordEpdCntID,
  _setRoleType,
  _setStartDate,
} from './aorcmActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getAorcmForm = createAsyncThunk(
  'stop/getAorcmForm',
  async (params) => {
    const { aorcmFormUrl, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(aorcmFormUrl, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

export const episodeAorcmSlice = createSlice({
  name: 'aorcm',
  initialState,
  reducers: {
    setRecordEpdCntID: _setRecordEpdCntID,
    setStartDate: _setStartDate,
    setEndDate: _setEndDate,
    setRoleType: _setRoleType,
    setCaseManagerOrParoleAgent: _setCaseManagerOrParoleAgent,
    newAorcm: (state, action) => action.payload,
    //resetAorcm: () => null,
  },
  extraReducers: {
    [getAorcmForm.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  setRecordEpdCntID,
  setStartDate,
  setEndDate,
  setRoleType,
  setCaseManagerOrParoleAgent,
  newAorcm,
  //resetAorcm
} = episodeAorcmSlice.actions;

export default episodeAorcmSlice.reducer;
